export default {"src":"/_next/static/media/accelerators-icon.d04e12f7.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};